import React from 'react';
import { Radio } from 'semantic-ui-react';
import styles from './customRadio.css';

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const CustomRadio = ( { ...props } ) => {
    return (
        <div className={ styles.wrapper }>
            <Radio { ...props } />
        </div>
    );
};

export default CustomRadio;
